import { render, staticRenderFns } from "./supplementaryPayBtn.vue?vue&type=template&id=533c884f&scoped=true"
import script from "./supplementaryPayBtn.vue?vue&type=script&lang=ts"
export * from "./supplementaryPayBtn.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533c884f",
  null
  
)

export default component.exports